import {
  useAvailableExtensions,
  useWalletObserver,
} from "@sundaeswap/wallet-lite";
import { FC, useState } from "react";

import { WalletConnectDialog } from "./WalletConnectDialog";

interface ConnectWalletButtonProps {
  className?: string;
  compact?: boolean;
}

export const ConnectWalletButton: FC<ConnectWalletButtonProps> = ({
  className,
  compact = false,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const extensions = useAvailableExtensions();
  const { isPending } = useWalletObserver();

  return (
    <>
      <button
        className={compact
          ? `sr-focus-ring sr-surface-pill inline-flex h-9 items-center gap-1.5 rounded-full px-3 text-sm text-sr-oat-milk transition-colors hover:bg-sr-surface-raised ${className ?? ""}`
          : `sr-focus-ring sr-btn-primary w-auto !px-4 !py-2 !text-sm !font-medium ${className ?? ""}`
        }
        disabled={isPending || extensions.length === 0}
        onClick={() => setIsOpen(true)}
        aria-label="Connect wallet"
      >
        {compact ? (
          <>
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true">
              <path d="M3 5.5A1.5 1.5 0 0 1 4.5 4h7A1.5 1.5 0 0 1 13 5.5v5A1.5 1.5 0 0 1 11.5 12h-7A1.5 1.5 0 0 1 3 10.5v-5Z" stroke="currentColor" strokeWidth="1.3" />
              <path d="M10.75 8h.01" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
            </svg>
            <svg width="12" height="12" viewBox="0 0 12 12" fill="none" aria-hidden="true">
              <path d="M3 4.5L6 7.5L9 4.5" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
          </>
        ) : isPending ? "Connecting..." : "Connect Wallet"}
      </button>
      <WalletConnectDialog
        open={isOpen}
        onClose={() => setIsOpen(false)}
      />
    </>
  );
};

export default ConnectWalletButton;
